import {Injectable, Injector} from '@angular/core';
import {AuthService} from './auth.service';
import {GfxHttpSrv} from './GfxHttpSrv';
import {FINGERPRINT_KEY} from '../enums/constants';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class AppConfig {
    private injector: Injector;

    constructor(private cookieService: CookieService, injector: Injector,
                private http: GfxHttpSrv) {
        this.injector = injector;

    }

    private get authService(): AuthService {
        return this.injector.get(AuthService);
    }


    load() {
        return this.startAppGetXsrfToken();
    }

    async startAppGetXsrfToken() {
        if (!sessionStorage.getItem(FINGERPRINT_KEY)) {
            const shortKey = Date.now().toString(36) + Math.random().toString(36).substr(2, 3);


            const tabSpecificFingerprint = `${shortKey}`;
            sessionStorage.setItem(FINGERPRINT_KEY, tabSpecificFingerprint);
        }
        const tokenXSRF = this.cookieService.get('XSRF-TOKEN');
        if (!tokenXSRF) {
            this.http.post('auth/start', {}).toPromise().then(res => {
                this.authService.initialize();
            });
        } else {
            this.authService.initialize();
        }

    }
}
